import apiClient from './apiClient';

export default {
  getServicesStatus: (config) => apiClient.get('/statistics/status', config),
};
